import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import {
    Form,
    FloatingLabel,
    Modal
} from "react-bootstrap";

import Utils from "../../../../Utils";
import ContextComponent from "../../../../AppContext";

const AddLabelPage = ({ props }) => {

    const { siteid } = useParams();
    let [currSiteId, setCurrSiteId] = useState(siteid);

    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);

    let LABEL_TYPE = Utils.LABEL_TYPE || {};
    let [type, setType] = useState(LABEL_TYPE[0].value);

    let [labelcode, setLabelcode] = useState("");
    let [labeltext, setLabeltext] = useState("");
    let [image, setImage] = useState("");
    let [description, setDescription] = useState("");

    const hideModal = (e) => {
        props.setAddModalCanOpen(false);
    };

    const labelcodeHandler = (e) => {
        setLabelcode(e.currentTarget.value);
    };

    const labelTypeHandler = (e) => {
        setType(e.currentTarget.value);
    }

    const labeltextHandler = (e) => {
        setLabeltext(e.currentTarget.value);
    };

    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetImage = e.currentTarget.attributes["imgname"].value;
        // let targetIndex = parseInt(
        //     e.currentTarget.attributes["imgindex"].value,
        //     10,
        // );
        document
            .querySelector(".indi-add-img-wrapper-" + targetImage)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetImage,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgPreviewEle.src = dataUri;
            setImage(dataUri);
            imgPreviewEle.src = dataUri;
        });
    };

    const labelDescriptionHandler = (e) => {
        setDescription(e.currentTarget.value);
    };


    const saveLabel = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Creating label",
        });

        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Label added successfully!",
                type: "success",
            });

            props.loadFreshLabels(currSiteId);
        };

        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Label addition failed",
                type: "error",
            });
            console.log(err);
        };

        let labelInfoFormData = {
            labelcode,
            description,
            labelType: type,
        };

        if (type === "TEXT") {
            labelInfoFormData = {
                ...labelInfoFormData,
                labeltext,
            };
        } else if (type === "IMAGE") {
            labelInfoFormData = {
                ...labelInfoFormData,
                image,
            };
        }
        // else if (type === "ORDERED_LIST" || type === "UNORDERED_LIST") {
        //     labelInfoFormData = {
        //         ...labelInfoFormData,
        //         // orderedList: List,
        //     };
        // }

        console.log(labelInfoFormData);
        try {
            // debugger;
            // console.log(formData);
            Utils.addLabel(currSiteId, labelInfoFormData).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => { }, [props.addModalCanOpen]);

    const handleClose = (e) => {
        props.setAddModalCanOpen(false);
    };

    return (
        <>
            <Modal centered show={props.addModalCanOpen} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add new Label</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="indi-add-form-wrapper d-flex flex-column">
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Label Code">
                                        <Form.Control
                                            type="text"
                                            className="indi-input-field"
                                            id="labelcode"
                                            placeholder="Enter Label Code"
                                            autoComplete="off"
                                            onChange={labelcodeHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Label Type">
                                        <Form.Select
                                            defaultValue={type}
                                            id="type"
                                            onChange={labelTypeHandler}
                                            size="sm"
                                            className="indi-input-field indi-input-select-field"
                                        >
                                            {LABEL_TYPE.map((label, index) => (
                                                <option value={label.value} key={index}>
                                                    {label.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </FloatingLabel>
                                </div>
                            </div>
                            {type === "TEXT" && (
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Label Text">
                                            <Form.Control
                                                as="textarea"
                                                className="indi-input-field"
                                                id="displayName"
                                                placeholder="Enter Label Text"
                                                autoComplete="off"
                                                onChange={labeltextHandler}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                            )}
                            {type === "IMAGE" && (
                                <div className="indi-add-form-item d-flex flex-row">
                                    <div className="indi-add-form-item-input col">
                                        <label htmlFor="iconImage" className="form-label">Label Image:</label>
                                        <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                            <input
                                                type="file"
                                                imgname="labelImage"
                                                id="labelImage"
                                                imgindex={0}
                                                className="indi-upload-picture-file-input"
                                                onChange={onChangeImage}
                                            />
                                            <div className="indi-add-img-wrapper"></div>
                                        </div>
                                    </div>
                                    <div className="indi-add-form-item-input col">
                                        <div className="indi-add-img-wrapper-labelImage d-none">no preview</div>
                                        <img
                                            src={image}
                                            alt="background"
                                            className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-labelImage"
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Label Description">
                                        <Form.Control
                                            as="textarea"
                                            className="indi-input-field"
                                            id="description"
                                            placeholder="Enter Label Text"
                                            autoComplete="off"
                                            onChange={labelDescriptionHandler}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                        </div>
                        <div className="indi-add-footer">
                            <div className="indi-add-page-footer-btn-wrapper float-right">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={hideModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={saveLabel}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddLabelPage;